// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be39127a","732":"e67f410c","977":"2bc33ff4"}[chunkId] + ".chunk.js";
};